"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSanitizedTx = void 0;
var _web3CoreHelpers = require("web3-core-helpers");
const getSanitizedTx = tx => {
  return new Promise((resolve, reject) => {
    if (!tx.gas && !tx.gasLimit && !tx.chainId) return reject(new Error('"gas" or "chainId" is missing'));
    if (tx.nonce < 0 || tx.gas < 0 || tx.gasPrice < 0 || !tx.gasPrice || tx.chainId < 0) return reject(new Error('Gas, gasPrice, nonce or chainId is lower than 0 or "gasPrice" is missing '));
    try {
      tx = _web3CoreHelpers.formatters.inputCallFormatter(tx);
      const transaction = tx;
      if (tx.to) transaction.to = tx.to;
      transaction.data = tx.data || '0x';
      transaction.value = tx.value || '0x';
      transaction.chainId = tx.chainId;
      resolve(transaction);
    } catch (e) {
      reject(e);
    }
  });
};
exports.getSanitizedTx = getSanitizedTx;
``;